import { render, staticRenderFns } from "./ColumnsOrderItem.vue?vue&type=template&id=31f275ef"
import script from "./ColumnsOrderItem.vue?vue&type=script&lang=js"
export * from "./ColumnsOrderItem.vue?vue&type=script&lang=js"
import style0 from "./ColumnsOrderItem.vue?vue&type=style&index=0&id=31f275ef&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports